import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Textarea } from "../ui/textarea";

export function ProjectFormFields({ formData, setFormData, clients, t }) {
  return (
    <>
      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">{t("projectName")}</Label>
        <Input
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          className="valhalla-input"
          required
          data-testid="project-name"
        />
      </div>

      <div className="space-y-2">
        <Label className="text-[#9CA3AF]">{t("description")}</Label>
        <Textarea
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          className="valhalla-input min-h-[100px]"
        />
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("client")}</Label>
          <Select
            value={formData.client_id || "none"}
            onValueChange={(v) =>
              setFormData({ ...formData, client_id: v === "none" ? "" : v })
            }
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue placeholder="Select client" />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="none">No client</SelectItem>
              {clients.map((client) => (
                <SelectItem key={client._id} value={client._id}>
                  {client.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("projectType")}</Label>
          <Select
            value={formData.project_type}
            onValueChange={(v) => setFormData({ ...formData, project_type: v })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="desarrollo">{t("development")}</SelectItem>
              <SelectItem value="mantenimiento">{t("maintenance")}</SelectItem>
              <SelectItem value="soporte">{t("support")}</SelectItem>
              <SelectItem value="interno">{t("internal")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("status")}</Label>
          <Select
            value={formData.status}
            onValueChange={(v) => setFormData({ ...formData, status: v })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="planeacion">{t("planning")}</SelectItem>
              <SelectItem value="activo">{t("active")}</SelectItem>
              <SelectItem value="en_pausa">{t("paused")}</SelectItem>
              <SelectItem value="cerrado">{t("closed")}</SelectItem>
              <SelectItem value="cancelado">{t("cancelled")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("priority")}</Label>
          <Select
            value={formData.priority}
            onValueChange={(v) => setFormData({ ...formData, priority: v })}
          >
            <SelectTrigger className="valhalla-input">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#151B26] border-[#242E42]">
              <SelectItem value="baja">{t("low")}</SelectItem>
              <SelectItem value="media">{t("medium")}</SelectItem>
              <SelectItem value="alta">{t("high")}</SelectItem>
              <SelectItem value="critica">{t("critical")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("startDate")}</Label>
          <Input
            type="date"
            value={formData.start_date}
            onChange={(e) =>
              setFormData({ ...formData, start_date: e.target.value })
            }
            className="valhalla-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("endDate")}</Label>
          <Input
            type="date"
            value={formData.end_date}
            onChange={(e) =>
              setFormData({ ...formData, end_date: e.target.value })
            }
            className="valhalla-input"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("budget")} ($)</Label>
          <Input
            type="number"
            value={formData.budget}
            onChange={(e) =>
              setFormData({
                ...formData,
                budget: parseFloat(e.target.value) || 0,
              })
            }
            className="valhalla-input"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-[#9CA3AF]">{t("estimatedHours")}</Label>
          <Input
            type="number"
            value={formData.estimated_hours}
            onChange={(e) =>
              setFormData({
                ...formData,
                estimated_hours: parseFloat(e.target.value) || 0,
              })
            }
            className="valhalla-input"
          />
        </div>
      </div>
    </>
  );
}
